module.exports = __webpack_public_path__ + "media/assets/images/SVG/logo-f395eeae95b8345af449a8cd56844665.svg";